module.exports = "<p>\n  details works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/details/details.component.html
// module id = ../../../../../src/app/details/details.component.html
// module chunks = main